// SPDX-License-Identifier: AGPL-3.0-or-later
// Reading amounts people type, in English or French Canadian style.
import type { Cents } from "@almanac/domain";

/** Strips currency and percent signs and spaces, and reads a French decimal comma. */
function number(text: string): number | null {
  const cleaned = text.replace(/[$%\s  ]/g, "").replace(/,(\d{1,2})$/, ".$1").replace(/,/g, "");
  if (cleaned === "") return null;
  const value = Number(cleaned);
  return Number.isFinite(value) && value >= 0 ? value : null;
}

/** "1,234.56", "1234,56 $" or "$1,234" as cents, or null if it is not an amount. */
export function parseMoney(text: string): Cents | null {
  const value = number(text);
  return value === null ? null : Math.round(value * 100);
}

/** "12.5", "12,5 %" or "12%" as a percentage, or null if it is not one between 0 and 100. */
export function parsePercent(text: string): number | null {
  const value = number(text);
  return value === null || value > 100 ? null : value;
}
